import classNames from 'classnames';
import { IconType } from '@react-icons/all-files/lib';

export function TabSelect<T extends string>(props: {
  onChange: (value: T) => void;
  className?: string;
  options: {
    text: string;
    Icon: IconType;
    value: T;
  }[];
  value: T;
}) {
  return (
    <div
      className={classNames(
        'inline-flex mt-10 items-center justify-center bg-gray-200 pt-2 px-2',
        props.className || 'rounded-md',
      )}
    >
      {props.options.map((o) => (
        <button
          key={o.text}
          onClick={() => {
            props.onChange(o.value);
          }}
          className={classNames(
            'p-2 rounded-md focus:outline-none transition-all',
            props.value === o.value
              ? 'bg-white text-gray-700'
              : 'text-gray-400 hover:text-gray-600',
          )}
        >
          <p className="flex items-center">
            <o.Icon className="mb-1 mr-1" />
            {o.text}
          </p>
        </button>
      ))}
    </div>
  );
}
